import * as React from 'react';
import { Header0 } from '@cian/ui-kit';
import { useSelector } from 'react-redux';
import { About as AboutComponent } from '../../components/About';
import { Layout } from '../../components/Layout';
import { getName } from '../../selectors/newbuilding';
import { NewbuildingDescriptionContainer } from '../NewbuildingDescription';

export const About = () => {
  const name = useSelector(getName);

  return (
    <Layout>
      <AboutComponent
        title={<Header0 as="h2">{`О жилом комплексе «${name}»`}</Header0>}
        description={<NewbuildingDescriptionContainer />}
      />
    </Layout>
  );
};

About.displayName = 'About';
